/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import AppButton from '../../../../shared/components/app-button/AppButton';
import { bookingDetailsRoute } from '../../constants/packageConstants';
import {
  formatIsoDate,
  formatPrice,
  isPackageEnquiry,
} from '../../utils/packageUtils';
import {
  transactionBookedOn,
  transactionGroup,
  transactionLead,
  transactionStatusLabel,
} from './packageTransactionUtils';

/** One package booking or enquiry in My Bookings (same layout as the eSIM / visa cards). */
function PackageTransactionCard({ booking }) {
  const enquiry = isPackageEnquiry(booking.status);
  const lead = transactionLead(booking);
  const travellers = Array.isArray(booking.passengers)
    ? booking.passengers.length
    : 0;
  const total = Number(booking.fare?.grandTotal) || 0;
  const joining = [booking.joiningCityLabel, booking.grade]
    .filter(Boolean)
    .join(' · ');
  const bookedOn = transactionBookedOn(booking);

  let amount = '—';
  if (total > 0) amount = formatPrice(total, booking.fare?.currency);
  else if (enquiry) amount = 'No charge';

  const openDetails = () => {
    window.open(bookingDetailsRoute(booking.pkgBookingId), '_blank');
  };

  return (
    <div className="cab-booking-list-card pkg-tx-card mb-2 p-2">
      <Row>
        <Col xs={12} md={12} lg={9}>
          <Row>
            <Col xs={12} sm={6} lg={5}>
              <div className="fs-12">Package</div>
              <div className="fw-600">{booking.packageName || '—'}</div>
            </Col>
            <Col xs={12} sm={6} lg={2}>
              <div className="fs-12">Departure</div>
              <div className="fw-600">
                {booking.departureDate
                  ? formatIsoDate(booking.departureDate)
                  : 'To be confirmed'}
              </div>
            </Col>
            <Col xs={12} sm={6} lg={2}>
              <div className="fs-12">Joining City</div>
              <div className="fw-600">{joining || '—'}</div>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <div className="fs-12">
                {enquiry ? 'Enquired On' : 'Booked On'}
              </div>
              <div className="fw-600">{bookedOn || '—'}</div>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12} sm={6} lg={5}>
              <div className="fs-12">Lead Traveller</div>
              <div className="fw-600">
                {lead.name || '—'}
                {travellers > 1 && (
                  <span className="pkg-tx-card__more">
                    {' '}
                    +{travellers - 1} more
                  </span>
                )}
              </div>
            </Col>
            <Col xs={12} sm={6} lg={4}>
              <div className="fs-12">Contact</div>
              <div className="fw-600 pkg-tx-card__contact">
                {[lead.email, lead.phone].filter(Boolean).join(' · ') || '—'}
              </div>
            </Col>
            {booking.bookingRef && (
              <Col xs={12} sm={6} lg={3}>
                <div className="fs-12">Supplier Ref</div>
                <div className="fw-600">{booking.bookingRef}</div>
              </Col>
            )}
          </Row>
        </Col>
        <Col xs={12} md={12} lg={3}>
          <div className="transaction-details">
            <div>
              <span>
                <b>Booking ID: </b>
                {booking.pkgBookingId}
              </span>
            </div>
            <div>
              <span>
                <b>Status: </b>
                <span
                  className={`pkg-tx-card__status pkg-tx-card__status--${transactionGroup(
                    booking,
                  )}`}
                >
                  {transactionStatusLabel(booking.status)}
                </span>
              </span>
            </div>
            <div>
              <span className="fw-600">{amount}</span>
            </div>
          </div>
          <div className="mt-2 d-flex gap-2 justify-content-end">
            <AppButton
              btnText={enquiry ? 'View Enquiry' : 'View Booking'}
              variant="secondary"
              onClick={openDetails}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}

PackageTransactionCard.propTypes = {
  booking: PropTypes.object.isRequired,
};

export default PackageTransactionCard;
